module.exports = __webpack_public_path__ + "static/media/slick.f38b2db1.css";